const InviteEmailTemplate = () => {
    return (`Hello! We are ready to check you in to your appointment.
Please make sure you are using a device with a good internet connection that has access to a camera and audio.`);
}

export default InviteEmailTemplate;
